export default __webpack_public_path__ + "bottom-2.93061e.png";